import { TOGGLE_HIDDEN_BLOCK_TYPE } from '../../constants/ActionTypes';

export const initialState = {
  items: [],
};

export default function hiddenblocktypes(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_HIDDEN_BLOCK_TYPE:
      let newItems = [];
      if (state.items.includes(action.blockType)) {
        newItems = state.items.filter((item) => item !== action.blockType);
      } else {
        newItems = [...state.items, action.blockType];
      }

      return {
        ...state,
        items: newItems,
      };
    default:
      return state;
  }
}
